module.exports = __webpack_public_path__ + "static/media/ProfessionalData.b6b6eac5.svg";